import axios from '../utils/axios';

export default function unpublishJob(adminId, data) {
    return (
        axios.post('/admin/' + adminId + '/transfer-jobs', data)
    )
}
